"use client";

import React from "react";
import ModalListPickerExample from "@/examples/modals/ModalListPickerExample";

export default function ModalListPickerPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalListPickerExample />
    </div>
  );
}
